import React, { useState, useEffect } from 'react';
import { OneOptionSelect } from '@pipltrust/apps-components';
import { useCookies } from 'react-cookie/es6';
import styles from './ChangeLanguage.module.less';
import AppConfig from '../../../Config/AppConfig';
import { LANGUAGES, DEFAULT_LANGUAGE, CHANGE_LANGUAGE_URL } from '../constants';

const ChangeLanguage = (props) => {
  const selectedLanguage = window.LANGUAGE_CODE || DEFAULT_LANGUAGE;
  const [newSelectedLanguage, setNewSelectedLanguage] = useState(selectedLanguage);

  const options = Object.keys(LANGUAGES).map((lang) => {
    return {
      value: lang,
      label: LANGUAGES[lang],
    };
  });

  const [cookies] = useCookies([]);
  const csrfToken = cookies[AppConfig.CSRF_COOKIE_NAME];
  useEffect(() => {
    if (selectedLanguage !== newSelectedLanguage) {
      const form = document.getElementById('lang-form');
      form.submit();
    }
  }, [newSelectedLanguage, selectedLanguage]);
  const selectStyles = {
    control: (baseStyle, state) => ({
      ...baseStyle,
      border: '1px solid #E4EBF6',
      borderRadius: '8px',
      '&:hover': {
        border: '1px solid #E4EBF6',
        boxShadow: 'none',
      },
      '&:focus': {
        border: '1px solid #E4EBF6',
        boxShadow: 'none',
      },
      '&:active': {
        border: '1px solid #E4EBF6',
        boxShadow: 'none',
      },
    }),
    indicatorSeparator: (baseStyle) => ({
      display: 'none',
    }),
    dropdownIndicator: (baseStyle) => ({
      ...baseStyle,
      color: 'black',
    }),
  };
  return (
    <div>
      <div className={styles.header} id="languageTitle">
        {gettext('Language')}
      </div>
      <div className={styles.languageInputContainer}>
        <form id="lang-form" method="POST" action={`${CHANGE_LANGUAGE_URL}?next=/profile/`}>
          <OneOptionSelect
            options={options}
            id="select-language"
            name="language"
            value={{ value: newSelectedLanguage, label: LANGUAGES[newSelectedLanguage] }}
            setValue={(e) => {
              setNewSelectedLanguage(e.value);
            }}
            styles={selectStyles}
          />
          <input type="hidden" name="csrfmiddlewaretoken" value={csrfToken} />
        </form>
      </div>
    </div>
  );
};

export default ChangeLanguage;
